function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
var PowerSwitch = function PowerSwitch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1,
    d: "M15.919 2.762a10.41 10.41 0 0 1 6.476 9.66c0 5.757-4.683 10.44-10.44 10.44-5.771 0-10.455-4.683-10.455-10.44 0-4.252 2.542-8.044 6.476-9.66a1 1 0 0 1 .76 1.85 8.42 8.42 0 0 0-5.236 7.81c0 4.655 3.787 8.44 8.44 8.44 4.669 0 8.455-3.785 8.455-8.44a8.415 8.415 0 0 0-5.236-7.81 1 1 0 1 1 .76-1.85M11.948 1a1 1 0 0 1 1 1v10.011a1 1 0 1 1-2 0V2a1 1 0 0 1 1-1"
  }));
};
export default PowerSwitch;